import React, { Component } from 'react';
import Table1 from './Table1';


class BelieveUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      isLoading: true,
      error: null,
    };
  }

  async componentDidMount() {
    try {
      const response = await fetch('https://believapi.ezinnovation.com/api/application_users', {
        headers: {
          Authorization: 'SSWS 00zk5kIxhdOOkmG10yK89JvP4UArceMemDf51_pXYM',
        },
      });
      const result = await response.json();
      console.log(result);
      if (result.success && result.data) {
        this.setState({ users: result.data, isLoading: false });
      } else {
        this.setState({ error: 'Failed to fetch users', isLoading: false });
      }
    } catch (error) {
      this.setState({ error: error.message, isLoading: false });
    }
  }

  render() {
    const { users, isLoading, error } = this.state;
    if (isLoading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>Error: {error}</div>;
    }
    return <Table1 data={users} />;
  }
}

export default BelieveUsers;



// WEBPACK FOOTER //
// ./src/components/pages/BelieveUsers.js